import { FC, SVGAttributes } from 'react';

type CheckSvgProps = SVGAttributes<SVGElement>;

export const CheckSvg: FC<CheckSvgProps> = ({ fill, ...props }) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
            <path
                d="M8.10328 15C7.88567 15.0009 7.67636 14.9089 7.52012 14.7437L3.58463 10.5775C3.50619 10.4939 3.4436 10.3943 3.40044 10.2844C3.35728 10.1745 3.33438 10.0563 3.33307 9.93674C3.33041 9.69522 3.41581 9.46244 3.57047 9.28961C3.72514 9.11678 3.9364 9.01806 4.15778 9.01516C4.37916 9.01226 4.59253 9.10543 4.75095 9.27416L8.10661 12.8251L15.2478 5.25881C15.4064 5.09007 15.62 4.99701 15.8416 5.00007C16.0631 5.00314 16.2745 5.1021 16.4291 5.27517C16.5838 5.44824 16.6691 5.68125 16.6663 5.92294C16.6635 6.16463 16.5728 6.3952 16.4141 6.56393L8.68644 14.7437C8.53019 14.9089 8.32089 15.0009 8.10328 15Z"
                fill={fill || '#F0EBE1'}
            />
        </svg>
    );
};
